/* eslint-disable no-return-assign */
import forEach from 'lodash/forEach';
import { error, debugError } from "../index";
import { langMap } from "../../const/lang";
export function formatMessage(message, variables) {
  if (variables && Object.keys(variables).length > 0) {
    var parsedMessage = message;
    forEach(variables, function (v, k) {
      var reg = new RegExp("{" + k + "}", 'g');
      // v 为 string | number , 但是有 value 是 null / undefined 的风险
      var value = typeof v === 'object' || typeof v === 'undefined' ? '' : v.toString();
      // 防止不可见字符出现嵌套,当参数中出现时支持替换回标准字符
      if (value.includes("\u206F\u206F")) {
        value = value.replace(/\u206F\u206F\d+\u206F\u206F/g, '').replace(/\u206F\u206F/g, '');
      }
      parsedMessage = parsedMessage.replace(reg, value);
    });
    return parsedMessage;
  }
  return message;
}
var StringFormat = /*#__PURE__*/function () {
  /**
   *  @param locale Languages that need to be localized
   *  @param locale Data dictionary, ICU grammar
   */
  function StringFormat(locale, lang) {
    this.locale = void 0;
    this.lang = void 0;
    this.locale = locale;
    this.lang = lang;
  }

  /**
   * Produce the formatted string for displaying to the user
   * @param des {id: string, defaultMessage: string }
   * @param variables {[propName: string]: string}
   * @param options {FormatOptions}
   */
  var _proto = StringFormat.prototype;
  _proto.format2 = function format2(des, variables, options) {
    var _this = this;
    var lang = options.lang;
    var formattedMessage = '';
    var usedLang = lang;
    var isMatched = false;
    var defaultMessage = des.defaultMessage || '';
    try {
      var _this$locale$lang, _langMap$lang;
      var message = ((_this$locale$lang = this.locale[lang]) === null || _this$locale$lang === void 0 ? void 0 : _this$locale$lang[des.id]) || '';
      if (message) {
        isMatched = true;
      }
      // 根据相识语种查找
      if (!message && (_langMap$lang = langMap[lang]) !== null && _langMap$lang !== void 0 && _langMap$lang.likeness) {
        langMap[lang].likeness.find(function (_lang) {
          var _this$locale$_lang;
          if ((_this$locale$_lang = _this.locale[_lang]) !== null && _this$locale$_lang !== void 0 && _this$locale$_lang[des.id]) {
            message = _this.locale[_lang][des.id];
            return usedLang = _lang;
          }
          return false;
        });
      }
      // 根据语种寻找 fallback的语种的翻译
      if (!message && window.__PANDA.langList) {
        window.__PANDA.langList.find(function (_lang) {
          var _this$locale$_lang2;
          if ((_this$locale$_lang2 = _this.locale[_lang]) !== null && _this$locale$_lang2 !== void 0 && _this$locale$_lang2[des.id]) {
            message = _this.locale[_lang][des.id];
            return usedLang = _lang;
          }
          return false;
        });
      }
      // 需要确保使用正确的message，没语言包使用dm
      message = message || defaultMessage;
      formattedMessage = formatMessage(message, variables);
    } catch (e) {
      var errorMessage = typeof e === 'string' ? e : 'Unknown error';
      error(des.id + " for " + lang + " failed: \n" + errorMessage);
      debugError(e);
    }
    return {
      message: formattedMessage || defaultMessage || des.id || '',
      usedLang: usedLang,
      isMatched: isMatched
    };
  }

  // 为了兼容老版本确保返回一致性
  ;
  _proto.format = function format(des, variables, options) {
    return this.format2(des, variables, options).message;
  };
  _proto.setLocale = function setLocale(locale) {
    this.locale = locale;
  };
  return StringFormat;
}();
export { StringFormat as default };